import { render, staticRenderFns } from "./users-data-vxe.vue?vue&type=template&id=bf3fd91a&"
import script from "./users-data-vxe.vue?vue&type=script&lang=js&"
export * from "./users-data-vxe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports